import { render, staticRenderFns } from "./myAcademic.vue?vue&type=template&id=421c6041&scoped=true"
import script from "./myAcademic.vue?vue&type=script&lang=js"
export * from "./myAcademic.vue?vue&type=script&lang=js"
import style0 from "./myAcademic.vue?vue&type=style&index=0&id=421c6041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c6041",
  null
  
)

export default component.exports